export default __webpack_public_path__ + "static/media/17.7aa60243.png";